export default [
  { title: "step1", enabled: true },
  { title: "step2", enabled: false },
  { title: "step3", enabled: false },
  { title: "step4", enabled: false },
  { title: "step5", enabled: false },
  { title: "step6", enabled: false },
  { title: "step7", enabled: false },
  { title: "step8", enabled: false },
  { title: "step9", enabled: false }
];
